module.exports = __webpack_public_path__ + "static/img/banner_AI穿透式监管方案.f6f4fb92.png";